const palette = {
  white: {
    primary: 'rgb(255, 255, 255)',
  },
  red: {
    toyota: 'rgb(177, 56, 52)',
  },
  green: {
    primary: 'rgb(75, 196, 23)',
  },
  blue: {
    clear: 'rgb(97, 218, 251)',
    primary: 'rgb(66, 129, 255)',
  },
  gray: {
    darker: 'rgb(40, 44, 52)',
    dark: 'rgb(147, 147, 162)',
    light: 'rgb(247, 248, 249)',
    lighter: 'rgb(210, 210, 210)',
    lighter2: 'rgba(225, 225, 225, 0.2)',
    primary: 'rgb(72, 72, 87)',
  },
  black: {
    primary: 'rgb(29, 31, 32)',
  },
  orange: {
    primary: 'rgb(254, 163, 49)',
  },
};

export default palette;
